import $ from 'jquery';
import Tabs from '../../ui/ui-tabs/ui-tabs.js'
import Swiper from 'swiper/bundle';
import '../../popups/popup-firmware/popup-firmware.js';
import '../../popups/popup-preview/popup-preview.js';


const tabsFirmware = new Tabs({
   visible: '.firmware-tabs .tab',
   collapse: '.firmware-list',
})

const tabsTop = document.querySelectorAll('.firmware-tabs.top .tab')
const tabsBottom = document.querySelectorAll('.firmware-tabs.bottom .tab')

tabsTop.forEach((item, index) => {
   item.onclick = function () {
      for (let tab of tabsBottom) {
         tab.classList.remove('active')
      }

      tabsBottom.forEach((tab, i) => {
         if (i === index) tab.classList.add('active')
      }) 
   }
})

tabsBottom.forEach(item => {
   item.onclick = function () {
      for (let tab of tabsBottom) {
         tab.classList.remove('active')
      }

      this.classList.add('active')
   }
})



let firmwareTabs = new Swiper('.firmware-tabs', {
   slidesPerGroup: 1,
   slidesPerView: 3, 
   slideToClickedSlide: true,
   loop: false,
   speed: 300,
   grabCursor: true,
   keyboard: {
      enabled: true,
      onlyInViewport: false,
   },
   breakpoints: {
      120: {
         slidesPerView: 1.5,
         centeredSlides: true
      },
      530: {
         slidesPerView: 1.5,
         centeredSlides: true
      },
      680: {
         slidesPerView: 3,
         centeredSlides: false
      }
   }
})

for (let item of firmwareTabs) {
   item.on('slideChange', function () {
      const currentIndex = item.activeIndex;
      // Loop through all sliders except the current one to update their position
      firmwareTabs.forEach(slider => {
         if (slider !== item) {
            slider.slideTo(currentIndex);
         }
      });
   });
}


